import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NewHub',
  data () {
    return {
      isLoading: {
        addHub: false,
        suggestions: false // Loading state for initial topic suggestions
      },
      topicName: '',
      topicDescription: '',
      suggestedTopics: [], // Store suggested topics from initial load
      openSuggestionPanels: [0], // Keep suggestions panel open by default
      unsubscribeAction: null // To store the unsubscribe function
    }
  },
  watch: {
    async $route () {
      await this.loadData()
    }
  },
  computed: {
    ...mapGetters([
      'activeContentplan',
      'activeWorkspace',
      'websocketMessages',
      'user'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    contentplanName () {
      return this.activeContentplan ? this.activeContentplan.name : ''
    },
    remainingCredits () {
      return this.activeWorkspace?.remaining_article_credits
    }
  },
  methods: {
    ...mapActions([
      'getTopicSuggestions',
      'topicPost',
      'sendWebsocketMessage'
    ]),
    async loadData () {
      document.title = 'New hub | ContentGecko'
      this.isLoading.suggestions = true
      this.suggestedTopics = []
      try {
        const suggestedTopics = await this.getTopicSuggestions({
          contentplanId: this.contentplanId
        })
        this.suggestedTopics = suggestedTopics || []
      } catch (error) {
        console.error('Error loading topic suggestions:', error)
      } finally {
        this.isLoading.suggestions = false
      }
    },
    selectSuggestion (topic) {
      this.topicName = topic.name
      this.topicDescription = topic.description
    },
    resetForm () {
      this.topicName = ''
      this.topicDescription = ''
    },
    async submitNewHub () {
      if (!this.topicName) return
      this.isLoading.addHub = true
      try {
        const newTopic = await this.topicPost({
          contentplanId: this.contentplanId,
          name: this.topicName,
          description: this.topicDescription
        })
        if (!newTopic?.id) throw new Error('Topic creation failed')
        this.$router.push({
          name: 'HubDetail',
          params: {
            workspaceId: this.workspaceId,
            contentplanId: this.contentplanId,
            topicId: newTopic.id
          }
        })
      } catch (error) {
        console.error('Failed to add hub:', error)
      } finally {
        this.isLoading.addHub = false
      }
    },
    handleWebsocketMessage (message) {
      if (message.type !== 'tracker') return
      const latestMessage = message.messages[message.messages.length - 1]
      if (latestMessage.topicId) {
        // Redirect to hub detail
        this.$router.push({
          name: 'HubDetail',
          params: {
            workspaceId: this.workspaceId,
            contentplanId: this.contentplanId,
            topicId: latestMessage.topicId
          }
        })
      }
    }
  },
  async mounted () {
    await this.loadData()
  },
  created () {
    this.unsubscribeAction = this.$store.subscribeAction({
      after: (action) => {
        if (action.type === 'handleWebsocketMessage' && action.payload) {
          this.handleWebsocketMessage(action.payload)
        }
      }
    })
  },
  beforeDestroy () {
    if (this.unsubscribeAction) {
      this.unsubscribeAction() // Unsubscribe before component is destroyed
    }
  }
}
